import request from "@/utils/interceptor.js";

/**
 * 预警工单主表列表
 * @param {Object} params
 * @param {string} [params.warningOrderMainId] 主表ID (uuid)
 * @param {string} [params.Sorting] 排序
 * @param {number} [params.SkipCount] 跳过条数
 * @param {number} [params.MaxResultCount] 每页条数
 */
export function getWarningOrderList(params) {
  return request({
    url: "/api/pas/warning-order-main",
    method: "get",
    params,
  });
}

/**
 * 预警工单详情
 * @param {string} id 工单ID (uuid)
 */
export function getWarningOrderDetail(id) {
  return request({
    url: `/api/pas/warning-order-main/${id}`,
    method: "get",
  });
}

/**
 * 更新预警工单（提交处理详情）
 * @param {string} id 工单ID (uuid)
 * @param {Object} data
 * @param {string} [data.remarks] 说明
 * @param {string} [data.closeReason] 关闭原因
 * @param {integer} [data.status] 工单状态：0=待处理,1=已处理,2=已关闭,3=已转单
 */
export function updateWarningOrder(id, data) {
  return request({
    url: `/api/pas/warning-order-main/${id}`,
    method: "put",
    data,
  });
}
/**
 * 咨询单（提交处理详情）
 * @param {string} TesterId 评测者ID
 */
export function getConsultOrder(params) {
  return request({
    url: `/api/pas/consult-order`,
    method: "get",
    params
  });
}
/**
 * 预警单详情列表
 * @param {string} warningOrderMainId 工单ID (uuid)
 */
export function getWarningOrder(params) {
  return request({
    url: `/api/pas/warning-order`,
    method: "get",
    params
  });
}
export default {
  getWarningOrderList,
  getWarningOrderDetail,
  updateWarningOrder,
  getConsultOrder,
  getWarningOrder
};
